import { useEffect } from 'react';

export const TabHandler = (tabName: string) => {
  useEffect(() => {
    document.title = tabName;
  }, [tabName]);
};